'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import classNames from 'classnames';

class UnstyledButton extends Component {
  constructor(...args) {
    super(...args);

    this.handleClick = evt => {
      const {
        disabled,
        onClick
      } = this.props;

      if (disabled || !onClick) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        onClick(evt);
      }
    };
  }

  render() {
    const _this$props = this.props,
          {
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className", "onClick"]);

    return /*#__PURE__*/_jsx("button", Object.assign({
      className: classNames('unstyled-button', className),
      onClick: this.handleClick
    }, rest));
  }

}

export default UnstyledButton;